'use client';

import { c as _c } from "react/compiler-runtime";
import { parseAsBoolean, parseAsStringLiteral, useQueryState } from 'nuqs';
export const PR_V2_FILE_TREE_VIEW_MODES = ['grouped', 'tree'] as const;
export type PrV2FileTreeViewMode = (typeof PR_V2_FILE_TREE_VIEW_MODES)[number];
export function usePrV2FileTreeState(t0) {
  const $ = _c(14);
  const defaultCollapsed = t0 === undefined ? false : t0;
  let t1;
  if ($[0] !== defaultCollapsed) {
    t1 = parseAsBoolean.withDefault(defaultCollapsed).withOptions({
      clearOnDefault: false
    });
    $[0] = defaultCollapsed;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [isCollapsed, setIsCollapsed] = useQueryState("v2FileTreeCollapsed", t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = parseAsStringLiteral(PR_V2_FILE_TREE_VIEW_MODES).withDefault("grouped");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [viewMode, setViewMode] = useQueryState("v2FileTreeView", t2);
  let t3;
  if ($[3] !== setIsCollapsed) {
    t3 = () => {
      setIsCollapsed(_temp);
    };
    $[3] = setIsCollapsed;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const toggleCollapsed = t3;
  let t4;
  if ($[5] !== setViewMode) {
    t4 = () => {
      setViewMode(_temp2);
    };
    $[5] = setViewMode;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const toggleViewMode = t4;
  let t5;
  if ($[7] !== isCollapsed || $[8] !== setIsCollapsed || $[9] !== setViewMode || $[10] !== toggleCollapsed || $[11] !== toggleViewMode || $[12] !== viewMode) {
    t5 = {
      isCollapsed,
      setIsCollapsed,
      toggleCollapsed,
      viewMode,
      setViewMode,
      toggleViewMode
    };
    $[7] = isCollapsed;
    $[8] = setIsCollapsed;
    $[9] = setViewMode;
    $[10] = toggleCollapsed;
    $[11] = toggleViewMode;
    $[12] = viewMode;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function _temp2(current_0) {
  return current_0 === "grouped" ? "tree" : "grouped";
}
function _temp(current) {
  return !current;
}